export const CraneIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M7 21V4" />
    <path d="M11 21V4" />
    <path d="M7 8l4-4" />
    <path d="M7 12l4-4" />
    <path d="M7 16l4-4" />
    <path d="M3 4h19" />
    <path d="M9 1v3" />
    <path d="M19 4v7" />
    <path d="M17 11h4l-1 2h-2z" />
    <path d="M4 21h10" />
  </svg>
);
